export const load = () => ({
	h1: 'Indow in the Media',
	title: 'Media Coverage',
	description:
		'Media coverage, articles, and reviews of Indow. Our window inserts provide highly efficient and cost-effective window performance at a fraction of the cost of replacement windows.',
	showTitle: true,
});
